import { ResetFormEmail } from './ResetFormEmail';

export type { TypeResetFormEmailProps } from './types';
export default ResetFormEmail;
